/** PostHog multivariate flag. Variants: "control" and "test". */
export const OUR_CUSTOMERS_REDESIGN_FLAG = "our-customers-redesign";

export type CustomersVariant = "control" | "test";

/**
 * Inline script that hands the server's flag value to the PostHog provider,
 * which passes it to `posthog.init({ bootstrap })`. `distinctId` is only given
 * when the server minted it, so posthog-js adopts it instead of making its own. Runs while the HTML is
 * parsed, before React hydrates and before the provider initialises.
 */
export function buildBootstrapScript(
  variant: CustomersVariant,
  distinctId?: string
): string {
  const bootstrap = {
    ...(distinctId ? { distinctID: distinctId } : {}),
    featureFlags: { [OUR_CUSTOMERS_REDESIGN_FLAG]: variant },
  };
  // `<` is escaped so no value can ever close the surrounding <script> tag.
  const json = JSON.stringify(bootstrap).replace(/</g, "\\u003c");
  return `window.__WF_POSTHOG_BOOTSTRAP__=${json};`;
}
